










































































import Vue from 'vue'
import Component from 'vue-class-component';
import api, { IResult } from "@/ts/functions";
import { IDataVueModel } from "@/ts/models/IDataVueModel";

@Component
export default class ThankYou extends Vue {
    name: string = 'ThankYou';
    isLoading: boolean = true;
    payType: string = "";
    items: IDataVueModel[] = [];
    payments: IDataVueModel[] = [];
    transactionId: string = "";
    total: number = 0;
    paymentAmount: number = 0;
    chaseConfirmationNumber: string = "";

    mounted() {
        this.payType = this.$route.params.payType;
        
        if (this.payType === "CRD") {
            api.confirmCredit(this.$route.params.applicationNumber)
                .then(result => this.setPayment(result, null))
                .catch((error: Error) => this.$toaster.error(error.message))
                .finally(() => this.getCheckout());
        } else if (this.payType === "ACH") {
            let data = this.getAchConfirmParameters();
            api.confirmAch(data)
                .then(result => this.setPayment(result, data))
                .catch((error: Error) => this.$toaster.error(error.message))
                .finally(() => this.getCheckout());
        } else {
            api.confirmNoPay(this.$route.params.applicationNumber)
                .then(result => this.setPayment(result, null))
                //.catch((error: Error) => this.$toaster.error(error.message))
                .finally(() => this.getCheckout());
        }
    }

    private getAchConfirmParameters(): any {
        return {
            applicationNumber: this.$route.params.applicationNumber,
            //returnSessionId: this.$route.query.returnSessionId,
            confirmationNumber: this.$route.query.confirmationNumber,
            transactionMode: this.$route.query.transactionMode,
            amount: this.$route.query.amount,
            code: "solidwastedivision"
        };
    }

    private getCheckout(): void {
        api.checkout(this.$route.params.applicationNumber)
                .then(result => {
                    this.items = result.items;
                    this.payments = result.payments;
                    this.total = result.total;
                    if (this.payType == 'CRD') { this.paymentAmount = this.total; }
                    this.transactionId = result.id;
                })
                .catch((error: Error) => this.$toaster.error(error.message))
                .finally(() => this.isLoading = false);
    }

    private setPayment(result: IResult, data: any): void {
        if (result.isSuccess) {
            if (data != null) {
                this.paymentAmount = ((result.message as any) as number) - 0;
                this.chaseConfirmationNumber = data.confirmationNumber;
            }
        } else {
            throw new Error(result.message as string);
        }
    }
}
